import SubscriberValidation from '../mixins/subscriber-validator.js'

const ListingMixin = (stateObject, title) => {
  return{
    data(){
      return {
        editDialog: false,
        deleteDialog: false,
        createDialog: false,
        editCreateDialogVisible: false,
      }
    },

    mixins: [SubscriberValidation],

    computed: {
      getDialogTitle(){
        if(this.createDialog) return `Dodaj ${title}`;
        else return `Uredi ${title}`
      }
    },

    methods: {
      deleteSelected(){
        this.$store.dispatch('manipulateData', {
          type: 'deleteSelectedData',
          stateObject,
        })
      },

      createOrUpdate(){
        if(this.objectsToValidate.length == 0){
          this.objectsToValidate = [this.$store.state.selectedObject];
        }
        this.formSubmitted();
        if(this.passed){
          if(this.createDialog){
            this.$store.dispatch('manipulateData', {
              type: 'postSelectedData',
              stateObject,
            })
          } else{
            this.$store.dispatch('manipulateData', {
              type: 'updateSelectedData',
              stateObject,
            })
          }
          this.editCreateDialogVisible = this.createDialog = this.editDialog = false;
        }
      }
    }
  }
}

export default ListingMixin;


// WEBPACK FOOTER //
// ./src/mixins/listing-mixin.js